import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { logout } from "../../Redux/slices/authSlice";

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { source } = location.state || { source: '' };
  
  const handleLogOut = () => {
    // Dispatch the logout action instead of calling it directly
    dispatch(logout());
    navigate("/login");
  };
  
  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-3">
      <h2 className="gradient-text">Success!</h2>
      <p className="info-text">
        {source === "register" ? "Welcome! You have Registered." : "Congratulations! You have updated your password."}
      </p>
      <Button
        className="gradient-button"
        onClick={handleLogOut}
      >
        Login
      </Button>
    </div>
  );
};

export default Success;